import type { MDXContent } from 'mdx/types';

import { type ReleaseFile, buildReleaseCatalog } from './releaseEntries';

// Every release entry in `content/releases`, built once at startup.
//
// Globbed here rather than imported from `collections/server`: that module
// also eagerly bundles every Agent Academy page in every language behind a
// top-level await, and the bell (app shell) must not pull it in. The
// `collection=releases` query still routes each file through fumadocs-mdx, so
// the frontmatter is validated and compiled like the generated collection.
//
// Frontmatter: bundled (the bell needs it on every page). Bodies: one lazy
// chunk per file, loaded when an entry is opened.
const PREFIX = '/content/releases/';

const frontmatters = import.meta.glob<Record<string, unknown>>(
  '/content/releases/*/index*.mdx',
  {
    eager: true,
    query: { collection: 'releases', only: 'frontmatter' },
    import: 'frontmatter',
  },
);

const bodies = import.meta.glob<{ default: MDXContent }>(
  '/content/releases/*/index*.mdx',
  { query: { collection: 'releases' } },
);

const files: ReleaseFile[] = Object.entries(frontmatters).map(
  ([key, frontmatter]) => ({
    ...frontmatter,
    info: { path: key.slice(PREFIX.length) },
    load: async () => ({ body: (await bodies[key]()).default }),
  }),
);

const catalog = buildReleaseCatalog(files);

if (catalog.errors.length > 0) {
  // `releaseContent.node-test.ts` fails CI on these; this only surfaces a
  // broken entry during local editing. Broken entries are left out.
  console.error('Invalid release entries:\n' + catalog.errors.join('\n'));
}

export const releaseEntries = catalog.entries;
